/**
 * PositionExpandedRow — renders the drill-down trade legs table
 * shown when a multi-trade position row is expanded.
 */
import { formatLocalTime } from '../../utils/helpers';

const PositionExpandedRow = ({ position }) => {
  const pnlColor = (val) => (val >= 0 ? '#059669' : '#dc2626');

  return (
    <tr>
      <td colSpan="13" style={{ padding: '0', backgroundColor: '#1e293b' }}>
        <div
          style={{
            padding: '1rem',
            border: '1px solid #334155',
            borderTop: 'none',
            margin: '0 1rem 1rem 1rem',
            borderRadius: '0 0 0.5rem 0.5rem',
          }}
        >
          {/* Header */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1rem',
            }}
          >
            <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#f8fafc', margin: 0 }}>
              Individual Trades for {position.symbol}
            </h4>
            <div style={{ fontSize: '0.875rem', fontWeight: '600', color: pnlColor(position.realizedPnl) }}>
              P&amp;L: ${position.realizedPnl?.toFixed(2) || '0.00'}
              <br />
              <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                (Buy: ${position.totalBuyAmount?.toFixed(2) || '0.00'} | Sell: $
                {position.totalSellAmount?.toFixed(2) || '0.00'})
              </span>
            </div>
          </div>

          {/* Trade legs table */}
          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '0.75rem',
                backgroundColor: '#0f172a',
                borderRadius: '0.25rem',
                border: '1px solid #334155',
              }}
            >
              <thead>
                <tr style={{ backgroundColor: '#1e293b' }}>
                  {['Side', 'Quantity', 'Price', 'Time', 'Amount'].map(
                    (h) => (
                      <th
                        key={h}
                        style={{ padding: '0.5rem', textAlign: 'left', fontWeight: '600', color: '#cbd5e1' }}
                      >
                        {h}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {position.trades.map((trade, index) => {
                  const price = parseFloat(trade.entryPrice || 0);
                  const qty = parseFloat(trade.quantity || 0);
                  const multiplier = trade.multiplier || (trade.securityType === 'OPTION' ? 100 : 1);
                  const amount = price * qty * multiplier;
                  const isBuy = trade.side === 'BUY' || trade.side === 'BUY_TO_OPEN' || trade.side === 'BUY_TO_CLOSE';
                  const sign = isBuy ? '-' : '+';

                  return (
                    <tr key={trade.id || index} style={{ borderBottom: '1px solid #334155', color: '#cbd5e1' }}>
                      <td style={{ padding: '0.5rem', fontWeight: '500' }}>{trade.side}</td>
                      <td style={{ padding: '0.5rem' }}>{trade.quantity}</td>
                      <td style={{ padding: '0.5rem' }}>${price.toFixed(2)}</td>
                      <td style={{ padding: '0.5rem' }}>
                        {formatLocalTime(trade.entryTime || trade.exitTime)}
                      </td>
                      <td
                        style={{
                          padding: '0.5rem',
                          fontWeight: '500',
                          color: isBuy ? '#dc2626' : '#059669',
                        }}
                      >
                        {sign}${amount.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default PositionExpandedRow;
